var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c(
        "actionBarComponent",
        {
          attrs: {
            slots: 2,
            title: _vm.$t(
              "__.Crud.pcp.configuracaoEtapaPCP.configuracaoEtapaPCP"
            ),
          },
          on: { onSave: _vm.save },
          scopedSlots: _vm._u([
            {
              key: "buttonSlot1",
              fn: function (ref) {
                var open = ref.open
                return _vm.model && _vm.model.id
                  ? _c(
                      "div",
                      {
                        attrs: { title: _vm.$t("__.ts.historicoAlteracoes") },
                        on: {
                          click: function ($event) {
                            open(
                              1,
                              _vm.$t("__.ts.historicoAlteracoes"),
                              "lg-modal"
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-history",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e()
              },
            },
          ]),
        },
        [
          _c(
            "div",
            { attrs: { slot: "modalSlot1" }, slot: "modalSlot1" },
            [
              _c("logEntidadeComponent", {
                attrs: {
                  registroId: _vm.model.id,
                  entidade: _vm.tipoLogEntidade,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { clas: "", novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.pcp.configuracaoEtapaPCP.gradePcp"),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("etapaGradePendenteId"),
                            expression: "errors.first('etapaGradePendenteId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaGradePendenteId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaGradePendente"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaGradePendenteId",
                            name: "etapaGradePendenteId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaGradePendenteId,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "etapaGradePendenteId", $$v)
                            },
                            expression: "model.etapaGradePendenteId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Components.parent.manipulacao.list_vue_html.manipu"
                ),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "etapaBloqueioManipulacaoId"
                            ),
                            expression:
                              "errors.first('etapaBloqueioManipulacaoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaBloqueioManipulacaoId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapabloqManipulacao"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaBloqueioManipulacaoId",
                            name: "etapaBloqueioManipulacaoId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaBloqueioManipulacaoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "etapaBloqueioManipulacaoId",
                                $$v
                              )
                            },
                            expression: "model.etapaBloqueioManipulacaoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.pcp.configuracaoEtapaPCP.sitEntrega"),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("etapaEntregaEmProducaoId"),
                            expression:
                              "errors.first('etapaEntregaEmProducaoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaEntregaEmProducaoId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaEntregaEmProducao"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaEntregaEmProducaoId",
                            name: "etapaEntregaEmProducaoId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaEntregaEmProducaoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "etapaEntregaEmProducaoId",
                                $$v
                              )
                            },
                            expression: "model.etapaEntregaEmProducaoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("etapaEntregaEmExecucaoId"),
                            expression:
                              "errors.first('etapaEntregaEmExecucaoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaEntregaEmExecucaoId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaEntregaEmExecucao"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaEntregaEmExecucaoId",
                            name: "etapaEntregaEmExecucaoId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaEntregaEmExecucaoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "etapaEntregaEmExecucaoId",
                                $$v
                              )
                            },
                            expression: "model.etapaEntregaEmExecucaoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "etapaEntregaEmSaiuParaEntregaId"
                            ),
                            expression:
                              "errors.first('etapaEntregaEmSaiuParaEntregaId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaEntregaEmSaiuParaEntregaId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaEntregaEmSaiuParaEntrega"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaEntregaEmSaiuParaEntregaId",
                            name: "etapaEntregaEmSaiuParaEntregaId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaEntregaEmSaiuParaEntregaId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "etapaEntregaEmSaiuParaEntregaId",
                                $$v
                              )
                            },
                            expression: "model.etapaEntregaEmSaiuParaEntregaId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("etapaEntregaEntregueId"),
                            expression:
                              "errors.first('etapaEntregaEntregueId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaEntregaEntregueId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaEntregaEntregue"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaEntregaEntregueId",
                            name: "etapaEntregaEntregueId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaEntregaEntregueId,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "etapaEntregaEntregueId", $$v)
                            },
                            expression: "model.etapaEntregaEntregueId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.pcp.configuracaoEtapaPCP.outros"),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("etapaEmissaoNotaFiscalId"),
                            expression:
                              "errors.first('etapaEmissaoNotaFiscalId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "etapaEmissaoNotaFiscalId",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.configuracaoEtapaPCP.etapaEmissaoNotaFiscal"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "etapaEmissaoNotaFiscalId",
                            name: "etapaEmissaoNotaFiscalId",
                            data: _vm.etapasOptions,
                          },
                          model: {
                            value: _vm.model.etapaEmissaoNotaFiscalId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "etapaEmissaoNotaFiscalId",
                                $$v
                              )
                            },
                            expression: "model.etapaEmissaoNotaFiscalId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "submit" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-save",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.salvar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }